import * as z from 'zod';
import { contentTypeSchema } from '../enums/content.js';
import { contentItemIdSchema, viewingSessionIdSchema } from '../primitives/id.js';
import { instantSchema, monotonicElapsedMsSchema } from '../primitives/time.js';
/**
 * What the device reports about the session it is currently running.
 *
 * `elapsedMs` comes from a monotonic clock and `startedAt` from the wall clock.
 * Reporting both lets the backend detect a device whose clock has been changed:
 * the two should advance together, and a large divergence is a signal rather
 * than a rounding error.
 */
export const viewingSessionSnapshotSchema = z.object({
    sessionId: viewingSessionIdSchema,
    contentItemId: contentItemIdSchema,
    contentType: contentTypeSchema,
    startedAt: instantSchema,
    elapsedMs: monotonicElapsedMsSchema,
    isPaused: z.boolean(),
});
/** How far the child has watched a given item, so playback can resume. */
export const playbackProgressSchema = z.object({
    contentItemId: contentItemIdSchema,
    positionSeconds: z.int().nonnegative(),
    updatedAt: instantSchema,
});
//# sourceMappingURL=session.js.map